export enum ServiceStatisticType {
  HOURLY = 'Hourly',
  DAILY = 'Daily',
  MONTHLY = 'Monthly'
}
